import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const WorkDatesNotificationModal = ({ show, onHide, removeUnapprovedDate }) => {
  const { t } = useTranslation();
  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header>
        <AiOutlineClose
          className="ml-auto cursor-pointer"
          size={24}
          onClick={removeUnapprovedDate}
        />
      </Modal.Header>
      <Modal.Body>{t('Your stated work dates have not taken place, is this correct?')}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-dark" onClick={removeUnapprovedDate}>
          {t('Cancel')}
        </Button>
        <Button className="outlines-primary" onClick={onHide}>
          {t('Approve Work Date')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WorkDatesNotificationModal;